import { Select } from 'antd';
import styled from 'styled-components';

export const Container = styled.span`
  cursor: auto;
`;

export const ModalTransp = styled.div`
  margin-top: 15px;
  width: 100%;
  cursor: auto;
`;

export const ModalEnd = styled.div`
  width: 100%;
  cursor: auto;
  font-weight: bold;
  font-style: normal;
  font-size: 14px;
  line-height: 22px;
  display: inline-block;
  white-space: nowrap;
  width: 89%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TilteEndTransp = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #bfbfbf;
`;

export const SelectControl = styled(Select)`
  @media (min-width: 600px) {
    width: 350px;
  }
  @media (max-width: 599px) {
    width: 85%;
  }
`;

export const EditTransp = styled.span`
  position: absolute;
  left: 85%;

  .ant-btn .anticon {
    color: ${(props) => props.theme.colors.btnEdit};
  }
`;

export const InputEnd = styled.span`
  border: 1px solid;  
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.textPrimary};
  align-items: flex-start;
  align-content: flex-start;
  padding: 4px 10% 4px 10%;
  cursor: not-allowed;
`;

export const TitleLabel = styled.div`
  padding-bottom: 10px;
`;
